import { MailboxType } from "../features/users/usersTypes";

export const GMAIL_SEND_SCOPE = "https://www.googleapis.com/auth/gmail.send";

export function hasGmailSendScope(scope?: string): boolean {
  return (
    scope
      ?.split(/\s+/)
      .filter(Boolean)
      .includes(GMAIL_SEND_SCOPE) ?? false
  );
}

export function resolveUserFullName(
  firstName?: string,
  lastName?: string,
  fullName?: string
): string {
  const trimmedFull = (fullName ?? "").trim();
  if (trimmedFull) return trimmedFull;

  const fn = (firstName ?? "").trim();
  const ln = (lastName ?? "").trim();
  return ln ? `${fn} ${ln}` : fn;
}

export function buildDisconnectedMailboxSignature(fullName: string): string {
  return `<p>Thank you,</p><p>Memorique</p><p>Personal Gifting Assistant to ${fullName}</p>`;
}

export function buildConnectedMailboxSignature(fullName: string): string {
  return `<p>Thank you,</p><p>${fullName}</p>`;
}

export function isMailboxConnected(
  mailboxType?: MailboxType,
  scope?: string
): boolean {
  if (mailboxType === MailboxType.GOOGLE) {
    return hasGmailSendScope(scope);
  }

  return mailboxType === MailboxType.MICROSOFT;
}

export function resolveSignatureForMailboxState(
  mailboxType: MailboxType | undefined,
  fullName: string,
  customSignature?: string,
  scope?: string
): string {
  if (isMailboxConnected(mailboxType, scope)) {
    return (customSignature ?? "").trim() || buildConnectedMailboxSignature(fullName);
  }

  return buildDisconnectedMailboxSignature(fullName);
}
